import { render, staticRenderFns } from "./unlicensed.vue?vue&type=template&id=55eb2276&scoped=true"
import script from "./unlicensed.vue?vue&type=script&lang=js"
export * from "./unlicensed.vue?vue&type=script&lang=js"
import style0 from "./unlicensed.vue?vue&type=style&index=0&id=55eb2276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eb2276",
  null
  
)

export default component.exports